import React from 'react';

interface BoardProps {
  board: string[][];
  highlightedCells: [number, number][];
}

const Board: React.FC<BoardProps> = ({ board, highlightedCells }) => {
  const isCellHighlighted = (row: number, col: number) => {
    return highlightedCells.some(([r, c]) => r === row && c === col);
  };

  return (
    <div className="board">
      {board.map((row, rowIndex) => (
        <div key={rowIndex} className="row">
          {row.map((letter, colIndex) => (
            <div
              key={`${rowIndex}-${colIndex}`}
              className={`cell ${isCellHighlighted(rowIndex, colIndex) ? 'highlighted' : ''}`}
            >
              {letter}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Board;
